import React from 'react';
import { Change } from './Change';
import { ChangeData } from '../../services/model';

type ChangeListProps = { isInternal: boolean; changes: ChangeData[] };

export const ChangeList: React.FC<ChangeListProps> = ({ changes }) => (
    <table className="table col-12">
        <thead>
            <tr>
                <th scope="col" className="cursor-pointer col-2">
                    Scope
                </th>
                <th scope="col" className="col-6">
                    Change
                </th>
                <th scope="col" className="col-1">
                    State
                </th>
            </tr>
        </thead>
        <tbody>
            {changes.map((data, index) => (
                <Change
                    changeId={data.changeId}
                    scope={data.scope}
                    isCompliant={data.isCompliant}
                    description={data.description}
                    documentationReference={data.documentationReference}
                    changeDetails={data.changeDetails}
                    key={index}
                />
            ))}
        </tbody>
    </table>
);
